import {Permission} from '../models/permission.model';
import {of, tap} from 'rxjs';
import {AuthenticatorService} from './authenticator.service';
import {Injectable} from '@angular/core';
import {PlanModelService} from './plan-model.service';
import {AppConfigService} from './app-config.service';
import { HttpClient } from '@angular/common/http';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {
    title = 'Authenticator Service';

    constructor(
        private authService: AuthenticatorService,
        private planModelService: PlanModelService,
        private appConfigService: AppConfigService,
        private http: HttpClient,
        private router: Router
    ) {}

    appPermissions: Permission[];

    loadPermissions() {
        if (this.appPermissions?.length) {
            return of(null);
        }

        return this.http.get<Permission[]>(this.appConfigService.settings.apiGatewayUrl + '/auth/permissions').pipe(
            tap({
                next: data => {
                    this.appPermissions = data;
                },
                error: error => {
                    console.error('Error loading permissions:', error);
                    this.appPermissions.length = 0;
                }
            })
        );
    }

    getPermissions(names: string[], firmNumber?: number) {
        firmNumber = firmNumber || this.authService.getUsersFirmNumber();
        const model = this.planModelService.getModel();

        const attrs: any = {};

        if (this.router.url.includes('plan') && !this.router.url.includes('plan-dashboard')) {
            if (!(model && model.planLodgementStage && model.pdfCreationMethod)) {
                return undefined;
            }
            attrs.planLodgementStage = model.planLodgementStage;
            attrs.pdfCreationMethod = model.pdfCreationMethod;
        }

        return this.appPermissions.filter(
            p =>
                names.some(s => s === p.name) &&
                p.firmNumber === firmNumber &&
                (Object.keys(p.attrs).length === 0 || Object.keys(attrs).every(k => attrs[k] === p.attrs[k]))
        );
    }

    hasEditPermission(names: string[], firmNumber?: number) {
        return this.getPermissions(names, firmNumber).some(permission => permission.editable);
    }

    isDisabledByPermissions(names: string[], firmNumber?: number) {
        return !this.hasEditPermission(names, firmNumber);
    }

    hasPermission(names, firmNumber?) {
        return this.getPermissions(names, firmNumber).length > 0;
    }
}
